import { render, staticRenderFns } from "./patternFillColorController.vue?vue&type=template&id=f63510e6&"
import script from "./patternFillColorController.vue?vue&type=script&lang=ts&"
export * from "./patternFillColorController.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports